import styled from 'styled-components';
import { Box } from '@rsos/base-components';

export const LoaderBox = styled(Box).attrs()`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(3px);
`;
